import $ from 'jquery';
import { initWbInfoModal } from './wb-info-modal';

require('magnific-popup');

let tooltipPopupInitialized = false;

function initTooltipPopup() {
  if (tooltipPopupInitialized) {
    return;
  }

  tooltipPopupInitialized = true;

  const selector = '[data-popup-content]';
  const closeSelector = '.js-tooltip-popup-close';

  const $btn = $(selector);
  const $html = $('html');
  const $document = $(document);
  const isWbEmbed = document.body.classList.contains('wb-embed');
  const wbInfoModal = isWbEmbed ? initWbInfoModal() : null;

  let lang = 'ru';
  if ($html.attr('lang')) {
    lang = $html.attr('lang');
  }

  let closeTitle = 'закрыть';
  if (lang === 'en') {
    closeTitle = 'close';
  }

  if (!$btn.length) return;

  $btn.on('click', function (e) {
    e.preventDefault();

    const content = $(this).data('popupContent');
    const title = $(this).data('popupTitle');

    if (wbInfoModal) {
      wbInfoModal.openModal({
        title: title || '',
        content: content || '',
      });
      return;
    }

    let html = '<div class="tooltip-popup">';

    if (title) {
      html += '<div class="tooltip-popup__header">';

      html += '<div class="tooltip-popup__title">' + title + '</div>';
      html += '<hr>';

      html += '</div>';//.tooltip-popup__header
    }

    html += '<div class="tooltip-popup__content">' + content + '</div>';
    html += '<div class="tooltip-popup__close-wrap"><button class="js-tooltip-popup-close btn btn_outline" type="button">' + closeTitle + '</button></div>';
    html += '</div>';

    $.magnificPopup.open({
      mainClass: 'tooltip-popup-wrap',
      items: {
        src: html,
        type: 'inline'
      }
    });
  });

  $document.on('click', closeSelector, function (e) {
    e.preventDefault();

    $.magnificPopup.close();
  });
}

export {initTooltipPopup};
